//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { convertTime } from '../../../components/helpers.js'
import { axiosGet } from '../../../axios/axios.js'
import ItemsSearchField from '../../../components/Field/ItemsSearchField.vue'
import { createFieldConfig } from '../../../components/QSelectUtils.js'
import WarningBanner from '../../../components/WarningBanner.vue'

export default {
  name: 'ReportForkliftTruckSelector',
  components: {
    ItemsSearchField,
    WarningBanner
  },
  props: {
    report: {
      type: Object,
      required: true
    },
    reportForkliftTrucks: {
      type: Array,
      required: true
    }
  },
  data: function () {
    return {
      loading: false,

      forkliftTruck: null,

      opened: false,
      callback: null,

      forkliftTruckFieldConfig: createFieldConfig({
        allRecordsFn: this.getForkliftTrucks,
        searchColumns: [r => r.vehicle.name]
      }),
      selectionDialogColumns: [
        {
          name: 'name',
          searchable: true,
          label: 'Название',
          align: 'left',
          defaultWidth: 100,
          field: record => record.vehicle.name,
          sortable: true
        },
        {
          name: 'requestsAll',
          label: 'Заявки',
          align: 'left',
          defaultWidth: 130,
          field: record => {
            if (record.brigadeRequest) {
              return [record.brigadeRequest]
            }
            return record.otherRequests || []
          },
          sortable: false,
          format: function (requests) {
            return requests.map(request => request.name).join(', ')
          }
        },
        {
          name: 'inUse',
          label: 'В эксплуатации',
          align: 'left',
          defaultWidth: 50,
          field: 'inUse',
          sortable: false,
          format: function (inUse) {
            return inUse ? 'Да' : 'Нет'
          }
        }
      ]
    }
  },
  computed: {
    disabled: function () {
      return this.loading || !this.forkliftTruck || this.acceptanceRequired(this.forkliftTruck)
    },
    warnings: function () {
      const item = this.forkliftTruck
      if (item) {
        if (item.brigadeRequest && item.brigadeRequest.acceptanceRequired) {
          return 'Для учёта выезда требуется регистрация подачи ТС «' + item.vehicle.name + '» на данный объект в Заявке на предоставление ТС №' + item.brigadeRequest.number
        }

        const warnings = []
        if (item.brigadeRequest) {
          warnings.push('Заявка на предоставление ТС №' + item.brigadeRequest.number + ' не была активна при выполнении выезда.')
        } else if (item.otherRequests && item.otherRequests.length) {
          warnings.push('Для ТС есть Заявки на предоставление, не назначенные на бригаду при выполнении выезда.')
        } else {
          warnings.push('Отсутствует Заявка на предоставление ТС.')
        }
        warnings.push('Информация об использовании ТС будет учтена только в данном отчёте.')

        return warnings
      }
      return null
    }
  },
  methods: {
    convertTime: convertTime,
    acceptanceRequired: function (item) {
      return !!(item && item.brigadeRequest && item.brigadeRequest.acceptanceRequired)
    },
    open: function (config) {
      this.callback = config.callback
      this.opened = true
    },
    onSave: function () {
      this.loading = true
      this.callback(this.forkliftTruck.id).then(() => {
        this.onClose()
      }).finally(() => {
        this.loading = false
      })
    },
    onClose: function () {
      this.opened = false
    },
    getForkliftTrucks: function () {
      const urlParams = new URLSearchParams()
      urlParams.set('report', this.report.id)

      return axiosGet({
        url: '/service/delta/vehicle/providedVehicles?' + urlParams.toString(),
        onSuccess: (response) => {
          let options = response.data.result
          for (const option of options) {
            option.id = option.vehicle.id || option.brigadeRequest && option.brigadeRequest.id || null
            option.inUse = option.vehicle.inUse
          }

          const vehicleProvisionRecords = this.reportForkliftTrucks.filter(record => !!record.vehicleProvisionId)
          const vehicleProvisionRecordsIds = new Set(vehicleProvisionRecords.map(record => record.vehicleProvisionId))
          const providedVehiclesIds = new Set(vehicleProvisionRecords.filter(record => !!record.vehicle && !!record.vehicle.id).map(record => record.vehicle.id))

          options = options.filter(option => {
            if (option.vehicle.id) {
              return !providedVehiclesIds.has(option.vehicle.id)
            } else if (option.brigadeRequest) {
              return !vehicleProvisionRecordsIds.has(option.brigadeRequest.id)
            }
            return false
          })
          options.sort((a, b) => {
            if (a.vehicle.inUse === b.vehicle.inUse) {
              if (a.vehicle.name === b.vehicle.name) {
                return 0
              }
              return a.vehicle.name > b.vehicle.name ? 1 : -1
            }
            return a.vehicle.inUse ? -1 : 1
          })
          return options
        },
        onFailure: 'Ошибка получения списка спецтехники, доступной для выбора'
      })
    }
  }
}
